import React, { useState, useEffect } from "react";
import { CalendarDaysIcon } from '@heroicons/react/20/solid';

const DaySelectionDialog = ({ dayOpen, setDayOpen }) => {
  const [tmpDayOpen, setTmpDayOpen] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setTmpDayOpen([...dayOpen]);
  }, []);

  // Function to toggle day selection
  const toggleDay = (day) => {
    // Update the 'checked' state of the clicked day in the dayOpen array
    setTmpDayOpen(prevState =>
      prevState.map(d =>
        d.day === day ? { ...d, checked: !d.checked } : d
      )
    );
  };

  // Generate preview (e.g., "Senin - Rabu" or "Senin, Kamis")
  const getDayPreview = () => {
    const selectedDays = tmpDayOpen.filter(day => day.checked).map(day => day.day);
    if (selectedDays.length === 0) return "Pilih hari...";
    const indices = selectedDays.map((day) => {
      // Find the index of the day from the dayOpen array
      return tmpDayOpen.findIndex((d) => d.day === day);
    });
    indices.sort((a, b) => a - b);

    // Check if the selected days are consecutive
    const isConsecutive = indices.every((val, i, arr) => i === 0 || val - arr[i - 1] === 1);

    if (isConsecutive) {
      return `${selectedDays[0]} - ${selectedDays[selectedDays.length - 1]}`;
    } else {
      return selectedDays.join(", ");
    }
  };

  return (
    <div className="relative flex w-full text-gray-400 focus-within:text-gray-600">
      {/* Input Field to Preview Selected Days */}
      <label className="relative flex w-full">
        <CalendarDaysIcon className="w-6 bg-gray-400 p-1 rounded-lg absolute top-1/2 transform -translate-y-1/2 left-3 text-white" />
        <input
          type="text"
          readOnly
          value={getDayPreview()}
          onClick={() => setIsOpen(true)}
          className="w-full text-xs bg-[#F5F5F5] rounded-lg py-2.5 pl-12 pr-6 focus:outline-none focus:border focus:border-primaryYellow focus:ring-1 focus:ring-primaryYellow cursor-pointer"
        />
      </label>

      {/* Dialog */}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-xl shadow-xl p-6 w-96">
            <h2 className="text-lg font-bold mb-4">Pilih Hari</h2>

            {/* Day Checkboxes */}
            <div className="space-y-2">
              {tmpDayOpen.map((day) => (
                <label
                  key={day.day}
                  className="flex items-center space-x-2 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={day.checked}
                    onChange={() => toggleDay(day.day)} // Toggle the checked state
                    className="w-4 h-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <span className="text-gray-700">{day.day}</span>
                </label>
              ))}
            </div>

            {/* Buttons */}
            <div className="flex justify-end mt-4 space-x-2">
              <button
                className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
                onClick={() => setIsOpen(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                onClick={() => {
                  setDayOpen(tmpDayOpen);
                  setIsOpen(false);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DaySelectionDialog;
